export default __webpack_public_path__ + "static/media/Group114511.718edbf2.svg";